export const DRAWER_WIDTH = 240;
export const REFINE_WIDTH = 300;
export const TABLE_PAGINATION_HEIGHT = 52;
